(function ($) {
	$(window).on('load', function () {
		let pagetop = '#pagetop';
		let footer = '.site-footer';

		$(pagetop).hide();
		$(footer).css('position', 'relative');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(footer).innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {

				if (window.matchMedia('(min-width: 769px)').matches) {
					$(pagetop).css({//フッターに到達したら
						"position": "absolute",
						"bottom": footHeight + 1
					});
				} else {
					$(pagetop).css({//フッターに到達したら
						"position": "absolute",
						"bottom": footHeight + 1
					});
				}
			} else { //フッターに到達する前
				if (window.matchMedia('(min-width: 769px)').matches) {
					$(pagetop).css({
						"position": "fixed",
						// "bottom": "0"
					});
				} else {
					$(pagetop).css({
						"position": "fixed",
						"bottom": "80px"
					});
				}
			}
		});
		$(pagetop).on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	});

})(jQuery);

document.addEventListener("DOMContentLoaded", function() {
    // ヘッダーの高さを取得する関数を定義
    const getHeaderHeight = () => {
        const header = document.querySelector('#masthead');
        return header ? header.offsetHeight : 0; // ヘッダーが存在しない場合に 0 を返す
    };

    // スクロールして目的のIDに到達させる関数
    const scrollToTarget = (targetElement, headerHeight) => {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
            top: targetPosition,
            behavior: "auto"
        });
    };

    // 目的のIDに到達するまで何度もスクロールを実行する関数
    const ensureScrollPosition = (targetElement, headerHeight) => {
        const intervalId = setInterval(() => {
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            if (Math.abs(window.pageYOffset - targetPosition) > 1) {
                scrollToTarget(targetElement, headerHeight);
            } else {
                clearInterval(intervalId); // 到達したらインターバルをクリア
            }
        }, 100); // 100msごとにチェックして再スクロール
    };

    const scrollToAnchor = function(event) {
        // no-scroll クラスを持つ場合は処理を中断
        if (this.classList.contains('no-scroll')) {
            return;
        }

        event.preventDefault();
        const targetID = this.getAttribute("href").split('#')[1];
        const targetElement = document.getElementById(targetID);
        if (targetElement) {
            const headerHeight = getHeaderHeight(); // ヘッダーの高さを取得
            ensureScrollPosition(targetElement, headerHeight);
        }
    };

    // すべてのアンカーリンクにクリックイベントを追加
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener("click", scrollToAnchor);
    });

    // ページ読み込み時にハッシュがある場合にスクロール
    if (window.location.hash) {
        const targetID = window.location.hash.substring(1);
        const targetElement = document.getElementById(targetID);
        if (targetElement) {
            const headerHeight = getHeaderHeight(); // ヘッダーの高さを再取得
            ensureScrollPosition(targetElement, headerHeight);
        }
    }
});



(function ($) {
	$(document).ready(function () {
		let fv = $('.p-front--fv');
		let footerMenu = $('.l-footer__sp-menu');
		let isVisible = false;

		// 画面幅を取得
		const windowWidth = $(window).width();

		// `.p-front--fv` が存在するかどうかを確認
		if (fv.length > 0) {
			// 画面幅が767px以下の場合のみ実行
			if (windowWidth <= 767) {
				$(window).on("scroll", function () {
					let fvBottom = fv.offset().top + fv.height();
					let windowBottom = $(window).scrollTop() + $(window).height();

					if (windowBottom > fvBottom && !isVisible) {
						// `.p-front--fv`領域を過ぎたらフェードイン
						footerMenu.fadeIn("fast");
						isVisible = true;
					} else if (windowBottom <= fvBottom && isVisible) {
						// `.p-front--fv`領域に入ったらフェードアウト
						footerMenu.fadeOut("fast");
						isVisible = false;
					}
				});

				// ページロード時の処理
				let fvTop = fv.offset().top;
				let windowTop = $(window).scrollTop();

				if (windowTop >= fvTop) {
					// `.p-front--fv`領域に入っていた場合、footerMenuを非表示にする
					footerMenu.hide();
					isVisible = false;
				} else {
					// `.p-front--fv`領域に入っていない場合、初めから非表示にする
					footerMenu.hide();
					isVisible = false;
				}
			}
		} else {
			// `.p-front--fv`が存在しない場合
			if (windowWidth <= 767) {
				// 画面幅が767px以下の場合、footerMenuを初めから表示状態にする
				footerMenu.show();
			} else {
				// 画面幅が767pxを超える場合、footerMenuを非表示にする
				footerMenu.hide();
			}
		}
	});
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
    const floatBanner = document.querySelector('.p-bnr--float');
    const frontFv = document.querySelector('.p-front--fv');

    // 初期設定
    if (frontFv) {
        floatBanner.style.opacity = 0;
        floatBanner.style.pointerEvents = 'none'; // 完全に透明の間はクリックなどを無効化
    } else {
        // .p-front--fvがない場合は最初から表示
        floatBanner.style.opacity = 1;
        floatBanner.style.pointerEvents = 'auto';
    }

    // .p-front--fvが画面内に見えているかをチェックする関数
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom >= 0;
    }

    // スクロール時やページ読み込み時に呼ばれる関数
    function checkBannerVisibility() {
        if (!frontFv) return; // .p-front--fvがない場合は処理しない

        if (isElementInViewport(frontFv)) {
            // .p-front--fvが画面内に見えている場合、ふわっとフェードアウト
            floatBanner.style.transition = 'opacity 0.5s ease';
            floatBanner.style.opacity = 0;
            floatBanner.style.pointerEvents = 'none'; // 非表示の間はクリックなどを無効化
        } else {
            // .p-front--fvが見えなくなった場合、ふわっとフェードイン
            floatBanner.style.transition = 'opacity 0.5s ease';
            floatBanner.style.opacity = 1;
            floatBanner.style.pointerEvents = 'auto'; // 表示されたらクリックなどを有効化
        }
    }

    // ページ読み込み時にチェック
    window.addEventListener('load', checkBannerVisibility);

    // スクロール時にチェック
    window.addEventListener('scroll', checkBannerVisibility);
});
